<template>
  <TextField
    :label="type == 'first' ? $tt('first_name') : $tt('last_name')"
    :hint="$tt('eng_as_in_passport')"
    :rules="[required]"
  />
</template>

<script setup lang="ts">
defineProps<{
  type: 'first' | 'last';
}>();

const { required } = useValidation();
</script>